import WINDOW from "../../../../utils/window";

/**
 *
 * @param {Map<"x" | "y", any>} pointer
 * @returns
 */
const getPointerMiddleX = (pointer) => {
  const width = /** @type {Number} */ (WINDOW.get("width"));
  const sideX = width / 2 - pointer.get("x");
  return 1 - Math.abs(sideX / (width / 2));
};

export default getPointerMiddleX;
